<div *ngIf="isLoading; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome" divCenter>
    <h1>Reporte de Files</h1>

    <div class="container">
      <h3>Escoge un Período:</h3>

      <mat-form-field appearance="outline">
        <input
          type="text"
          placeholder="ej: 2025-03"
          matInput
          [formControl]="fileControl"
          [matAutocomplete]="autoPeriodo"
        />
        <mat-autocomplete
          #autoPeriodo="matAutocomplete"
          [displayWith]="getOptionText"
          (optionSelected)="onPeriodoSelected($event.option.value)"
        >
          <mat-option
            *ngFor="let periodo of filteredOptions | async"
            [value]="periodo"
          >
            {{ periodo.descripcion }} ({{ periodo.codigo }})
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <i-tabler
        name="trash-x"
        class="iconObs"
        (click)="clearFilters()"
      ></i-tabler>
      <i-tabler
        name="refresh"
        (click)="loadMain()"
        class="iconLastMinute"
      ></i-tabler>
    </div>

    <div
      *ngIf="selectedPeriodo"
      class="container"
      style="
        margin: 10px 0;
        padding: 10px;
        background-color: #e3f2fd;
        border-radius: 4px;
      "
    >
      <strong>Período seleccionado:</strong>
      {{ formatPeriodoDescripcion(selectedPeriodo) }}
      <span style="color: #666">({{ selectedPeriodo }})</span>
    </div>

    <div
      class="container"
      *ngIf="fileCountsDataSource && fileCountsDataSource.data.length > 0"
    >
      <table mat-table [dataSource]="fileCountsDataSource" matSort>
        <!-- Generar columnas dinámicamente para cada estado -->
        <ng-container
          *ngFor="let estado of fileDisplayedColumns2"
          [matColumnDef]="estado"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-estado"
          >
            {{ estado }}
          </th>
          <td mat-cell *matCellDef="let element" class="column-estado">
            {{ element[estado] || 0 }}
          </td>
        </ng-container>

        <!-- Definir las filas del header y contenido -->
        <tr mat-header-row *matHeaderRowDef="fileDisplayedColumns2"></tr>
        <tr mat-row *matRowDef="let row; columns: fileDisplayedColumns2"></tr>
      </table>
    </div>

    <div
      *ngIf="!fileCountsDataSource || fileCountsDataSource.data.length === 0"
      class="no-data"
    >
      <h2>No hay datos disponibles</h2>
    </div>

    <div
      style="
        margin: 20px 0;
        padding: 15px;
        background-color: #f5f5f5;
        border-radius: 4px;
        border: solid 1px #ccc;
      "
    >
      <h3 style="margin-bottom: 15px">Información del filtro:</h3>

      <div style="display: flex; gap: 10px; margin-bottom: 8px">
        <strong style="min-width: 200px">Total de archivos mostrados:</strong>
        <span>{{ totalTotal }}</span>
      </div>

      <div style="display: flex; gap: 10px; margin-bottom: 8px">
        <strong style="min-width: 200px">Total de períodos disponibles:</strong>
        <span>{{ allPeriodos.length }}</span>
      </div>

      <div *ngIf="allPeriodos.length > 0" style="display: flex; gap: 10px">
        <strong style="min-width: 200px">Períodos disponibles:</strong>
      </div>
      <div class="periods-grid">
        <div class="period-item" *ngFor="let p of allPeriodos">
          {{ p.descripcion }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
